import { MypageNovelNovelIdDeleteInputModel } from "./DeleteInputModel"
import { httpDelete } from "../../../../../libs/http/httpDelete"

export const deleteMypageNovelNovelId = (
  model: MypageNovelNovelIdDeleteInputModel,
): Promise<void> => {
  return httpDelete<void>("/v1/mypage/novel/{novel_id}", model)
}
